module.exports = __webpack_public_path__ + "static/media/10.5ac3b433.jpg";